/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { isEditionAuthorized, isDeletionAuthorized, openEditBookPage, deleteBooks }
) => (
  <>
    {
      isEditionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="book-edit-tooltip">Düzenle</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => openEditBookPage(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    }
    {
      isDeletionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="books-delete-tooltip">Sil</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
          onClick={() => deleteBooks(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    }    
  </>
);